/**
 * 当前插件仅在布局组件中的按钮中使用
 * 点击按钮，导出当前用户的pdf，需要通过当前userinfo
 */
import $ from "jquery"
export default {
  methods: {
    exportPdfPlugin() {
      if (this.isSsrPage() === false) return
      this.exportPdfBind = this.exportPdf.bind(this)
      $(".exportPdf")[0].addEventListener("click", this.exportPdfBind, false)
    },
    exportPdf() {
      const url = `pdf/${window.location.hostname}/${this.$store.state.userInfo.uid}/我的毕业报告_${this.$store.state.userInfo.realname}`
      window.open(url)
    }
  },
  beforeDestroy() {
    $(".exportPdf")[0]?.removeEventListener("click", this.exportPdfBind, false)
  }
}
